import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Chip from "@mui/material/Chip";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import ImageEditorModal from "pages/de/posts/components/ImageEditorModal";

import { getAllPostImages, handleUpdatePostContent } from "utils/helper";
const CROPPED_IMAGE_TYPE = "image/jpeg";

const PostImageWrapper = ({
  handleClick = null,
  setPost,
  post,
  item,
  isEdit = false,
  handleDelete,

  ...rest
}) => {
  const [imageEditorVisible, setImageEditorVisible] = useState(false);

  const handleAfterEditImage = (item, newImageItem) => {
    const payload = {
      ...item,
      img: {
        name: item?.img?.name || "cropped_img.jpg",
        url: newImageItem?.url,
        type: CROPPED_IMAGE_TYPE,
      },
      dimensions: { width: newImageItem?.width, height: newImageItem?.height },
    };
    const newPost = handleUpdatePostContent(post, payload);
    setPost(newPost);
  };

  const handleDefaultDelete = () => {
    const newPost = handleUpdatePostContent(post, item, true);
    console.log(newPost);
    setPost(newPost);
  };

  return (
    <>
      <div
        style={{
          position: "relative",
        }}
        className="hover-parent"
      >
        <ImageCardWrapper
          data={item?.img}
          isOriginalSize={true}
          width={"100%"}
          height={"auto"}
          sx={{ height: "auto", width: "100%" }}
          onClick={
            handleClick
              ? handleClick
              : () => {
                  isEdit ? setImageEditorVisible(true) : null;
                }
          }
          {...rest}
        />
        {item?.type == "style" ? (
          <Chip
            label="Style"
            sx={{ position: "absolute", left: 10, top: 10 }}
            color={"secondary"}
            size="small"
          />
        ) : null}
        {isEdit ? (
          <SuiBox
            aria-label="close"
            onClick={handleDelete ? () => handleDelete(item) : () => handleDefaultDelete()}
            sx={{
              position: "absolute",
              right: 10,
              top: 10,
              backgroundColor: (theme) => theme.palette.grey[500],
              cursor: "pointer",
              opacity: 0,
              borderRadius: "50%",
              height: 25,
              width: 25,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            className="hover-children"
          >
            <CloseIcon color="white" />
          </SuiBox>
        ) : null}
      </div>
      {imageEditorVisible && item ? (
        <ImageEditorModal
          handleClose={() => setImageEditorVisible(false)}
          visible={imageEditorVisible}
          selectedItem={item}
          handleAfterSave={handleAfterEditImage}
        />
      ) : null}
    </>
  );
};

export default PostImageWrapper;
